const btnNav = document.getElementById('btn-nav');
btnNav.onclick = function () {
    document.querySelector('html').classList.toggle('nav-open');
    this.querySelector('.hamburger').classList.toggle('is-active');
}
